module.exports = __webpack_public_path__ + "img/f1be010.svg";